import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from "@angular/core";
import { SpsIcon, SpsIconSize } from "@spscommerce/ds-shared";

@Directive({
    selector: "[spsIcon]"
})
export class SpsIconDirective implements OnInit, OnChanges {
    @Input() spsIcon: SpsIcon;
    @Input() spsIconSize = SpsIconSize.MEDIUM;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        this.addClass("sps-icon");
        this.addClass(`sps-icon-${this.spsIcon}`);
        this.addClass(`sps-icon--${this.spsIconSize}`);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.spsIcon) {
            this.replaceClass(
                `sps-icon-${changes.spsIcon.previousValue}`,
                `sps-icon-${changes.spsIcon.currentValue}`
            );
        }

        if (changes.spsIconSize) {
            this.replaceClass(
                `sps-icon--${changes.spsIconSize.previousValue}`,
                `sps-icon--${changes.spsIconSize.currentValue}`
            );
        }
    }

    addClass(className: string) {
        this.renderer.addClass(this.elementRef.nativeElement, className);
    }

    replaceClass(oldClassName: string, newClassName: string) {
        this.renderer.removeClass(this.elementRef.nativeElement, oldClassName);
        this.addClass(newClassName);
    }
}
